<template>
	<div class="form" id="success-sended">
		<div class="form__icon">
			<SuccessBigIcon />
		</div>
		<div class="form__title" v-if="!newPassword">
			<h2 class="form__title-text">E-mail enviado com sucesso!</h2>
			<p class="form__title-subtext">Verifique seu e-mail para cadastrar sua nova senha.</p>
		</div>
		<div class="form__title" v-else>
			<h2 class="form__title-text">Senha cadastrada com sucesso!</h2>
		</div>
		<div class="actions">
			<div class="actions__btn">
				<button id="back-btn" class="actions__btn-back" @click="goToLogin()">Login</button>
			</div>
		</div>
	</div>
</template>

<script>
import SuccessBigIcon from '@/components/shared/Icons/SuccessBigIcon.vue';

export default {
	name: 'SuccessSended',
	props: {
		newPassword: {
			default: false,
		},
	},
	components: {
		SuccessBigIcon,
	},
	data: () => ({
		login: null,
		loginRequired: false,
	}),
	mounted() {},
	methods: {
		goToLogin() {
			if (this.newPassword) {
				return this.$router.push('/login');
			}
			this.$emit('handleSuccess');
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'SuccessSended.scss';
</style>
